const  data ={
    languages:['fa','en','fr','de','re'],
    countries:['ir','ca','us','de'],
    states:["qc",'On',"Bc","Nb",'Nf'],
    cities:["Montreal",'Laval',"Brossard","sherbrook",'magoc']
}

export default data;
